import React from 'react';
import { ShowStatusItem } from '../ItemDisplay';
import {
  convertBEToFESparePart,
  SearchSparePart,
} from '../../services/SparePartService';

interface ProductPartItemsType {
  items: SearchSparePart[];
}

const ProductPartItems = ({ items }: ProductPartItemsType) => {
  if (!items) return null;

  return (
    <>
      {items.map((itm: SearchSparePart, index: number) => {
        return (
          <React.Fragment key={index}>
            <ShowStatusItem item={convertBEToFESparePart(itm)} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default ProductPartItems;
